import {EventEmitter, Inject, Injectable} from "@angular/core";
import {NgbModal, NgbModalConfig, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {TranslateService} from "@ngx-translate/core";
import {Observable, firstValueFrom, from} from "rxjs"
import {HttpClient} from "@angular/common/http";
import {ToastService} from "../toast/toast.service";
import {ErrorhandlerService} from "../errorhandler.service";
import * as PubSub from 'pubsub-js'
import {PubsubEnum} from "../../enums/pubsub.enum";
import { UserBlockedService } from "../user-blocked/user-blocked-service.service";
import {AuthenticationService} from "../autenticacion/authentication.service";
import {TokenUnlockComponent} from "../../../views/token-unlock/token-unlock.component";
import {environment} from "../../../../environments/environment";

@Injectable({providedIn: "root"})
export class TokenUnlockService {

  private modalRef!: NgbModalRef;
  private baseEndpoint: string;
  public tokenBlockError: boolean = false;
  public showContactGacModal: boolean = false;
  public closeModalTokenUnlock: EventEmitter<void> = new EventEmitter<void>();
  public internalMsg: boolean = false;
  translations: any

  constructor(
    private modalService: NgbModal,
    private http: HttpClient,
    private modalConfig: NgbModalConfig,
    private translate: TranslateService,
    private toastService: ToastService,
    private errorHandler: ErrorhandlerService,
    private authenticationService: AuthenticationService,
    private userBlockedService: UserBlockedService
  ) {
    this.baseEndpoint = environment.apiUser
    modalConfig.backdrop = 'static';
    modalConfig.keyboard = true;
  }

  openInternalUnlockToken() {
    this.modalRef = this.modalService.open(TokenUnlockComponent);
    this.modalRef.componentInstance.modalMessage = 'Internal message';
  }

  openExternalUnlockToken(fromInside: boolean = false, {title, paragraph, translations}, sendRegularCode: boolean = true) {
    this.configModal(title, paragraph, translations, sendRegularCode);
    if (sendRegularCode) this.sentEmailCode(fromInside)
    this.internalMsg = fromInside
  }

  getRef() {
    return this.modalRef;
  }

  async sentEmailCode(translations?: any, fromInside?: boolean): Promise<any> {
    let response
    try {
      response = await firstValueFrom(this.http.get<any>(`${this.baseEndpoint}/token/unlock/email`))
    } catch (err: any) {
      console.log(err)
      if (err.error.errorCode === "USR02") {
        this.toastService.showToast(translations.USR02)
      } else if (err.error.errorCode == "USR05") {
        this.toastService.showToast(translations.USR05)
      } else if (err.error.errorCode === "USR06") {
        this.toastService.showToast(translations.USR06)
        this.close()
        if (fromInside) {
          this.userBlockedService.open(translations.USER_BLOCKED)
        } else {
          this.tokenBlockError = true
          this.authenticationService.logOutWithoutRedirect()
        }
      }
      return;
    }

    this.toastService.showToast(translations.MESSAGE_SENT, 'success', 'Success')

    this.internalMsg = fromInside || false
  }

  configModal(title: string, paragraph: string,translations: any, sendRegularCode: boolean) {
    this.modalRef = this.modalService.open(TokenUnlockComponent);
    this.modalRef.componentInstance.sendRegularCode = sendRegularCode
    this.modalRef.componentInstance.title = title
    this.modalRef.componentInstance.paragraph = paragraph
    this.modalRef.componentInstance.translations = translations
  }

  async openUnlockToken(translations: any, fromInside: boolean = false) {
    let response
    this.configModal2();
    this.sentEmailCode(translations, fromInside)
  }

  configModal2() {
    this.modalRef = this.modalService.open(TokenUnlockComponent);
  }

  close() {
    PubSub.publish(PubsubEnum.CLOSE_UNLOCKTOKEN_MODAL);
    this.closeModalTokenUnlock.emit();
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  closeWithRef(modalRef: any) {
    if (modalRef) {
      this.modalRef.close();
    }
  }

  validateCode(code: string): Observable<any> {
    return this.http.post<any>(`${this.baseEndpoint}/token/unlock`, {
      code
    })
  }
}
